<template>
  <section class="hero is-primary is-fullheight is-fullwidth">
    <div class="hero-body">
      <div class="container">
        <div class="columns is-centered">
          <div
            class="column is-full-mobile  is-8-tablet is-7-desktop is-6-widescreen"
          >
            <figure style="width:250px; height:50px; margin:auto;">
              <span class="titleInvalidLink">SKILLCOURT</span>
            </figure>
            <div class="text-welcome">
              <p>Invalid link! Please go back to your mail and try again.</p>
              <br />
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>
<script>
import $ from "jquery";

export default {
  name: "InvalidLink",
  data: function() {
    return {};
  },
  components: {},
  computed: {},
  methods: {},
  mounted: function() {},
};
</script>
